import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const CONTRACT_URL = `${API_URL}/contract`

export interface ContractLine {
  brand: {_id: string; name: string}
  thematic: {_id: string; name: string}
  hours_total: number
  hour_amount: number
  total_amount: number
}

export interface ContractEntry {
  date: string
  from: string
  to: string
  brand: {name: string}
  location: {name: string}
  thematic: {name: string}
  hours_total: number
}

export interface Contract {
  _id: string
  period: string
  date: string
  type: string
  name: string
  total_amount: number
  collaborator: {
    _id: string
    firstname: string
    lastname: string
    address?: string
    zipcode?: string
    city?: string
    registration_number: string
    job: string
  }
  client: {
    _id: string
    name: string
  }
  entity: {
    _id: string
    name: string
    slug: string
  }
  lines: ContractLine[]
  entries: ContractEntry[]
  created: {
    date: string
    user: string
  }
}

export interface ContractListResponse {
  status: string
  data: Contract[]
  count: number
}

export const getContracts = (params: {
  lookup?: string
  filter_period?: string
  collaborator?: string
}): Promise<ContractListResponse> => {
  return axios.get(CONTRACT_URL, {params}).then((res) => res.data)
}

export const generateContracts = (period: string, date: string): Promise<any> => {
  return axios.post(CONTRACT_URL, {period, date}).then((res) => res.data)
}

export const downloadContractPdf = (id: string): Promise<Blob> => {
  return axios
    .get(`${CONTRACT_URL}/${id}`, {responseType: 'blob'})
    .then((res: AxiosResponse<Blob>) => res.data)
}
